import { gql } from '@apollo/client'

const GET_ALL_INVOICES = gql`
  query getAllInvoices($first: Int, $offset: Int) {
    invoices(first: $first, offset: $offset, orderBy: INVOICE_NUMBER_DESC) {
      nodes {
        id
        invoiceDate
        invoiceNumber
        requestByIdRequest {
          id
          requestAddress
          title
        }
      }
      totalCount
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
    }
  }
`

export default GET_ALL_INVOICES
